import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import LoadingOverlay from 'react-loading-overlay';
import { userActions } from "../../actions";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        const {user}=this.props.user;


        const {loading}=this.props;

        return (  

            

            <div>
                <LoadingOverlay active={loading}                 
                    spinner
                    text='در حال دریافت ...'
                />
               
                
                <div className="navbar-header">
                
                    <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>
                    <img src="../../../content/images/logo_white.png" width="42" style={{marginTop:7}}></img>
                    <a className="navbar-brand" href="#">
                   
                        سامانه جامع دادپزشک
                    </a>
                    
                </div>
                {/* <!-- /.navbar-header --> */}

                <ul className="nav navbar-top-links navbar-right">

                    <li className="dropdown">
                        <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                            
                            <span className="fullname hidden-sm hidden-md">{
                                user.currentOfficeId &&
                                user.offices && user.offices.find(x=>x.Id==user.currentOfficeId).Title

                            }</span>
                            <i className="fa fa-caret-down"></i>
                        </a>
                        <ul className="dropdown-menu dropdown-user">

                            {user.offices && user.offices.map(item=>{
                                return <li><a href="#" onClick={userActions.setCurrentOffice(item.Id)}> {item.Title}</a> </li> 
                                   
                            })}

                        </ul>
                    </li>
                </ul>

                <ul className="nav navbar-top-links navbar-left">

                    <li className="dropdown">
                    { loading &&

                        <a href="#">
                        <i className="fa fa-spinner fa-spin "></i>
                        </a>

                    }
                    
                    </li>
                    <li className="dropdown">
                        <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                            <i className="fa fa-user fa-fw"></i>
                            <span className="fullname hidden-sm hidden-md">{user.FullName}</span>
                            <i className="fa fa-caret-down"></i>
                        </a>
                        <ul className="dropdown-menu dropdown-user">
                            <li>
                            <Link to="/changepass"><i className="fa fa-user fa-fw"></i> تغییر کلمه عبور</Link>
                            </li>
                           
                            <li className="divider"></li>
                            <li><Link to="/login"><i className="fa fa-sign-out fa-fw"></i> خروج</Link>
                            </li>
                        </ul>
                    </li>
                </ul>
        </div>

        );
    }
}
function mapStateToProps(state) {
    const { authentication } = state;
    const { loading } = state.objs;
    const { user } = authentication;
    return {
        user,
        loading
    };
}
 
export default connect(mapStateToProps)(Header);

